import { render } from "./WandAnimation.vue?vue&type=template&id=1fb9f393"
import script from "./WandAnimation.vue?vue&type=script&lang=js"
export * from "./WandAnimation.vue?vue&type=script&lang=js"

import "./WandAnimation.vue?vue&type=style&index=0&id=1fb9f393&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__